// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.load-extension_code_EPS16,
.load-extension_unsandboxed-container_ZWhek,
.load-extension_unsandboxed-warning_OVqu3,
.load-extension_sandboxed_E1U6p {
    margin: 8px 0;
}

.load-extension_unsandboxed-container_ZWhek {
    display: flex;
    align-items: center;
}

.load-extension_unsandboxed-checkbox_bzFF3 {
    margin-right: 8px;
}

.load-extension_unsandboxed-warning_OVqu3 {
    padding: 0.5rem;
    border-radius: 0.25rem;
    background-color: rgba(255, 81, 81, 0.25);
    border: 1px solid red;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-security-manager-modal/load-extension.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;;IAII,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yCAAyC;IACzC,qBAAqB;AACzB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.code,\n.unsandboxed-container,\n.unsandboxed-warning,\n.sandboxed {\n    margin: 8px 0;\n}\n\n.unsandboxed-container {\n    display: flex;\n    align-items: center;\n}\n\n.unsandboxed-checkbox {\n    margin-right: 8px;\n}\n\n.unsandboxed-warning {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n    background-color: rgba(255, 81, 81, 0.25);\n    border: 1px solid red;\n}\n"],"sourceRoot":""}]);
// Exports
export var code = `load-extension_code_EPS16`;
var _1 = `load-extension_unsandboxed-container_ZWhek`;
export { _1 as "unsandboxed-container" };
export var unsandboxedContainer = `load-extension_unsandboxed-container_ZWhek`;
var _2 = `load-extension_unsandboxed-warning_OVqu3`;
export { _2 as "unsandboxed-warning" };
export var unsandboxedWarning = `load-extension_unsandboxed-warning_OVqu3`;
export var sandboxed = `load-extension_sandboxed_E1U6p`;
var _3 = `load-extension_unsandboxed-checkbox_bzFF3`;
export { _3 as "unsandboxed-checkbox" };
export var unsandboxedCheckbox = `load-extension_unsandboxed-checkbox_bzFF3`;
export default ___CSS_LOADER_EXPORT___;
